<lib-autocomplete
  #autocomplete
  [formControl]="control"
  [placeholder]="placeholder"
  [options]="selectOptions()"
  [loading]="loader()"
  [filterStartsWith]="filterStartsWith"
  [strictSelection]="true"
  [widthPx]="cellWidth"
  [heightPx]="cellHeight"
  (optionsRequested)="loadOptions()"
  (optionSelected)="onOptionSelected()"
></lib-autocomplete>
